import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { useTranslation } from "react-i18next";
import {
  DISPLAY_RULE_GROUPS,
  DISPLAY_RULE_SCOPE,
  evaluateDisplayRules,
} from "./dashboardDisplayRules";

const SCOPE_LABEL_KEY = {
  [DISPLAY_RULE_SCOPE.ALWAYS]: "dashboard.displayRules.scopeAlways",
  [DISPLAY_RULE_SCOPE.GLOBAL]: "dashboard.displayRules.scopeGlobal",
  [DISPLAY_RULE_SCOPE.ZONE]: "dashboard.displayRules.scopeZone",
  [DISPLAY_RULE_SCOPE.USER]: "dashboard.displayRules.scopeUser",
  [DISPLAY_RULE_SCOPE.DATA]: "dashboard.displayRules.scopeData",
};

const RuleRow = ({ rule, t }) => {
  const statusKey = rule.locked
    ? "dashboard.displayRules.statusLocked"
    : rule.visible
      ? "dashboard.displayRules.statusVisible"
      : "dashboard.displayRules.statusHidden";
  const statusClass = rule.locked
    ? "is-locked"
    : rule.visible
      ? "is-visible"
      : "is-hidden";

  return (
    <article className="dashboard-display-rule">
      <div className="dashboard-display-rule-top">
        <h4 className="dashboard-display-rule-title">
          {t(`dashboard.displayRules.${rule.id}.title`)}
        </h4>
        <div className="dashboard-display-rule-tags">
          <span className={`dashboard-display-rule-status ${statusClass}`}>
            {t(statusKey)}
          </span>
          <span className="dashboard-display-rule-scope">
            {t(SCOPE_LABEL_KEY[rule.scope])}
          </span>
        </div>
      </div>
      <p className="dashboard-display-rule-description">
        {t(`dashboard.displayRules.${rule.id}.description`)}
      </p>
      <p className="dashboard-display-rule-configure">
        {t(`dashboard.displayRules.${rule.id}.configure`)}
      </p>
    </article>
  );
};

export const DashboardDisplayRulesModal = ({ isOpen, onClose, context }) => {
  const { t } = useTranslation();
  const rules = evaluateDisplayRules(context);

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      centered
      modalClassName="dashboard-display-rules-modal"
      className="dashboard-display-rules-dialog"
      backdropClassName="dashboard-display-rules-backdrop"
    >
      <ModalHeader className="dashboard-display-rules-header" toggle={onClose}>
        {t("dashboard.displayRules.title")}
      </ModalHeader>
      <ModalBody className="dashboard-display-rules-body">
        <p className="dashboard-display-rules-intro">
          {t("dashboard.displayRules.intro")}
        </p>
        {DISPLAY_RULE_GROUPS.map((group) => {
          const groupRules = rules.filter((rule) => rule.group === group);
          if (groupRules.length === 0) return null;
          return (
            <section key={group} className="dashboard-display-rules-group">
              <h3 className="dashboard-display-rules-group-title">
                {t(`dashboard.displayRules.group.${group}`)}
              </h3>
              {groupRules.map((rule) => (
                <RuleRow key={rule.id} rule={rule} t={t} />
              ))}
            </section>
          );
        })}
      </ModalBody>
    </Modal>
  );
};
